import { render, staticRenderFns } from "./OperaProjectSocreWindow.vue?vue&type=template&id=21c40a2c&scoped=true&"
import script from "./OperaProjectSocreWindow.vue?vue&type=script&lang=js&"
export * from "./OperaProjectSocreWindow.vue?vue&type=script&lang=js&"
import style0 from "./OperaProjectSocreWindow.vue?vue&type=style&index=0&id=21c40a2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c40a2c",
  null
  
)

export default component.exports